"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFiles = _interopRequireDefault(require("react-files"));

var _classnames = _interopRequireDefault(require("classnames"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _clientAwsS = require("@devsta/client-aws-s3");

var _commonReact = require("@devsta/common-react");

var _uiKit = require("@devsta/ui-kit");

var _utils = require("../../../../../../../../../common/utils");

require("../styles/upload-srt.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var UploadSRT = /*#__PURE__*/function (_Component) {
  _inherits(UploadSRT, _Component);

  var _super = _createSuper(UploadSRT);

  function UploadSRT(props) {
    var _this;

    _classCallCheck(this, UploadSRT);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getCaptionName", (0, _memoizeOne.default)(function (caption) {
      if (!caption || !caption.metaData) {
        return '';
      }

      try {
        var _JSON$parse = JSON.parse(caption.metaData),
            filename = _JSON$parse.filename;

        return filename;
      } catch (e) {
        return '';
      }
    }));

    _defineProperty(_assertThisInitialized(_this), "createUpdateCaptionRecord", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(type, file) {
        var _this$props, assetId, organisationId, currentCaptions, apolloClient, lang, createFile, updateFile, metaData, _ref2, assetFileId;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, assetId = _this$props.assetId, organisationId = _this$props.organisationId, currentCaptions = _this$props.currentCaptions, apolloClient = _this$props.apolloClient, lang = _this$props.lang, createFile = _this$props.createFile, updateFile = _this$props.updateFile;
                metaData = {
                  lang: lang.toLowerCase(),
                  filename: file.name
                };

                if (!currentCaptions[type]) {
                  _context.next = 6;
                  break;
                }

                _context.t0 = {
                  data: {
                    createFile: currentCaptions[type]
                  }
                };
                _context.next = 9;
                break;

              case 6:
                _context.next = 8;
                return createFile({
                  organisationId: organisationId,
                  input: {
                    assetId: assetId,
                    type: type,
                    metaData: metaData
                  }
                });

              case 8:
                _context.t0 = _context.sent;

              case 9:
                _ref2 = _context.t0;
                assetFileId = _ref2.data.createFile.assetFileId;
                _context.prev = 11;
                _context.next = 14;
                return (0, _clientAwsS.uploadFile)({
                  apiClient: apolloClient,
                  file: file,
                  bucketKey: "organisation/".concat(organisationId, "/asset/").concat(assetId, "/file-").concat(type, "-").concat(lang.toUpperCase()),
                  organisationId: organisationId
                });

              case 14:
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t1 = _context["catch"](11);
                return _context.abrupt("return", (0, _commonReact.notify)({
                  content: 'Something went wrong.',
                  type: 'error'
                }));

              case 19:
                _context.next = 21;
                return updateFile({
                  organisationId: organisationId,
                  assetFileId: assetFileId,
                  input: {
                    assetId: assetId,
                    status: 'UPLOADED',
                    metaData: metaData
                  }
                });

              case 21:
                return _context.abrupt("return", {
                  assetFileId: assetFileId,
                  assetId: assetId,
                  status: 'UPLOADED',
                  metaData: JSON.stringify(metaData)
                });

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[11, 16]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleSrtLoaded", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(reader, file) {
        var updateCurrentCaptions, vttContent, srtAssetFile, vttFile, vttAssetFile;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                updateCurrentCaptions = this.props.updateCurrentCaptions;
                vttContent = (0, _utils.convertSrtToVtt)(reader.result);

                if (vttContent) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", void 0);

              case 4:
                _context2.next = 6;
                return this.createUpdateCaptionRecord('CAPTION', file);

              case 6:
                srtAssetFile = _context2.sent;
                vttFile = new File([vttContent], 'caption.vtt');
                _context2.next = 10;
                return this.createUpdateCaptionRecord('VTT_CAPTION', vttFile);

              case 10:
                vttAssetFile = _context2.sent;
                updateCurrentCaptions(srtAssetFile, vttAssetFile);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function (_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleFilesChange", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(files) {
        var file, reader;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (files.length) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                file = files[files.length - 1];
                _context3.prev = 3;
                reader = new FileReader();
                reader.readAsText(file);

                reader.onloadend = function () {
                  return _this.handleSrtLoaded(reader, file);
                };

                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](3);
                throw _context3.t0;

              case 12:
                _this._filePickerRef.removeFiles();

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[3, 9]]);
      }));

      return function (_x5) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "setFilePickerRef", function (ref) {
      if (_this._filePickerRef || !ref) {
        return;
      }

      _this._filePickerRef = ref;
    });

    _this.handleSrtLoaded = _this.handleSrtLoaded.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(UploadSRT, [{
    key: "render",
    value: function render() {
      var _this$props$currentCa = this.props.currentCaptions,
          CAPTION = _this$props$currentCa.CAPTION,
          VTT_CAPTION = _this$props$currentCa.VTT_CAPTION;
      var uploadedCaptionName = this.getCaptionName(CAPTION);
      var isCaptionUploaded = CAPTION && VTT_CAPTION;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "upload-srt"
      }, /*#__PURE__*/_react.default.createElement(_reactFiles.default, {
        dropActiveClassName: "upload-srt--drop-active",
        onChange: this.handleFilesChange,
        accepts: ['.srt'],
        minFileSize: 1,
        clickable: true,
        ref: this.setFilePickerRef
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('upload-srt__box', {
          'upload-srt__box__preview': isCaptionUploaded
        })
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "upload-srt__box--drop-hover"
      }, /*#__PURE__*/_react.default.createElement("span", null, "Drop your files here to upload")), isCaptionUploaded ? /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        className: "upload-srt__preview"
      }, uploadedCaptionName || 'Uploaded') : /*#__PURE__*/_react.default.createElement("div", {
        className: "upload-srt__text"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        className: "upload-srt__text__title"
      }, "Upload Caption here"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, null, "Drag & drop your file or\xA0", /*#__PURE__*/_react.default.createElement("span", {
        className: "upload-srt__text--highlight"
      }, "browse"))))));
    }
  }]);

  return UploadSRT;
}(_react.Component);

var _default = UploadSRT;
exports.default = _default;